module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-traditional_v2-9fc91ca629e9e913ec2337b6a21887a6.pdf";